<template>
<div>

  <router-view/>
  </div>
</template>


<style>
@import './assets/main.css';
@import './assets/tool.css';
@import './assets/shop.css';
</style>
